<template>
    <div>
        <van-nav-bar @click-left="$router.go(-1)" left-arrow left-text="返回" />
        <div class="wrap">
            <div class="card">
                <div class="title">
                    订阅服务协议
                </div>
                <p style="text-indent:2rem">
                    欢迎使用由济南亚爱特软件有限公司（以下简称“本公司”）提供的订阅服务！本许可协议在用户使用订阅服务之前签署。在签署本协议之前，代表用户已经完全了解、知悉、接受和遵守本服务协议的全部内容。如果用户对本协议的任何条款表示异议，可以选择不使用本订阅服务。
                </p>
                <p class="first"> 一、一般条款 </p>
                <p class="second">1. 本协议是您 (以下称为“用户”) 与本公司达成的关于订阅服务使用的协议。</p>
                <p class="second">2. 服务的所有权及经营权应当归本公司所有。</p>

                <p class="first">二、服务内容</p>
                <p class="second">1. 本公司提供的订阅服务，可能会不断丰富您使用本服务的界面、形式等（具体以本公司提供的为准）。</p>
                <p class="second">2. 本服务内容包含用户订阅孩子进出学校8秒短视频或消息订阅等功能，这些服务可能根据公司运营策略的变化、用户需求的变化，随着因服务版本不同、或服务提供方的单方判断而被优化或修改，或因定期、不定期的维护而暂缓提供。</p>
                <p class="second">3. 同时本公司保留在任何时候自行决定对服务或服务任何部分及其相关功能、应用软件变更、升级、修改、转移的权利。对于上述行为，本公司均不需通知，并且对您和任何第三人不承担任何责任。</p>

                <p class="first">三、使用规范</p>
                <p class="second">1. 用户使用软件及服务须遵守本协议及法律。用户不得从事下列行为：</p>
                <p class="third">1.1. 对软件执行逆向工程，如破解、反编译或进行其他尝试以获取软件的源代码；</p>
                <p class="third">1.2. 在软件执行时通过修改或伪造指令及数据来增加、删除或更改软件的功能或执行效果，或就上述目的以其他方式操作软件或向公众传播有关方法，无论是否用于商业用途；</p>
                <p class="third">1.3. 使用软件从事对网络安全有害的任何行为，包括但不限于：使用未经授权的数据或存取未经授权的服务器/账户；未经授权存取公共网络或其他操作系统，并删除、修改或添加任何存储的数据；未经授权而企图侦测、扫描或测试软件系统或网络的弱点或进行其他破坏网络安全的行为；试图干扰或破坏软件系统或网站的正常运行，蓄意传播恶意软件或病毒，或执行破坏或干扰正常网络信息服务的其他行为；伪造 TCP/IP 数据包的名称或部分名称；</p>
                <p class="third">1.4. 以任何非法的方式、针对任何非法目的或与本协议下的许可使用方式不一致的任何方式，使用本公司提供的服务；</p>
                <p class="second">2. 您明白并同意：</p>
                <p class="third">2.1. 本公司将判断用户是否涉嫌违反上述使用规范，并根据判断结果暂停或终止向您授予使用许可，或根据本协议采取其他限制措施；</p>
                <p class="third">2.2. 如果您违反上述使用规范而对第三方造成损害，您须以您自身名义独立承担责任，并使本公司免受任何由此产生的损失或费用损害；</p>
                <p class="third">2.3. 用户须就其违反有关法律或违反本协议而导致本公司产生或蒙受的任何及所有损失、第三方索赔、行政处罚、损害或费用 (包括合理的律师费、调查及证据收集费用) 提供弥偿，并使本公司免受损失。</p>

                <p class="first">四、服务费用</p>
                <p class="second">1.本服务的任何免费试用或免费功能和服务不应视为本公司放弃后续收费的权利。本公司有权变更收费标准，若您继续使用则需按本公司公布的收费标准支付费用，如您不同意收费应当立即停止服务的使用。</p>
                <p class="second">2.您理解并知悉，您在使用服务时，包括视频等服务时，需要消耗您的流量，您应当自行支付使用本服务可能产生的上网费，您继续使用服务视为您对消耗流量的同意。</p>

                <p class="first">五、服务中止或终止</p>
                <p class="second">1.您同意，鉴于互联网服务的特殊性，本公司有权随时中止、终止或致使中止终止服务或其任何部分；对于服务之中止或终止，本公司无需向您发出通知。</p>
                <p class="second">2.您了解并同意，本公司可能定期或不定期地对提供网络服务的平台设备、设施和软硬件进行维护或检修，如因此类情况而造成收费服务在合理时间内中止，本公司无需承担责任及赔偿。</p>
                <p class="second">3.如存在下列违约情形之一，本公司可立即对用户中止或终止服务，并要求用户赔偿损失：</p>
                <p class="third">3.1.用户使用收费服务时未按规定支付相应服务费；</p>
                <p class="third">3.2.用户违反服务使用规范之规定。</p>

                <p class="first">六、隐私政策</p>
                <p class="second">1.您在该服务注册的账户具有密码保护功能，以确保您基本信息资料的安全。</p>
                <p class="second">2.本公司努力采取各种合理的物理、电子和管理方面的安全措施来保护您的信息，使您存储在平台中的信息和通信内容不会被泄漏、毁损或者丢失，包括但不限于SSL、信息加密存储、数据中心的访问控制。我们对可能接触到信息的员工也采取了严格管理，包括但不限于根据岗位的不同采取不同的权限控制，与他们签署保密协议，监控他们的操作情况等措施。本公司会按现有技术提供相应的安全措施来保护您的信息，提供合理的安全保障，本公司将在任何时候尽力做到使您的信息不被泄漏、毁损或丢失，但同时也请您注意在信息网络上不存在绝对完善的安全措施，请妥善保管好相关信息。</p>
                <p class="second">3.本公司有权根据实际情况自行决定您在本软件及服务中数据的最长储存期限、服务器中数据的最大存储空间等，本公司对您自身原因导致的数据丢失或被盗以及在本软件及服务中相关数据的删除或储存失败不承担责任。</p>

                <p class="first">七、知识产权声明</p>
                <p class="second">1. 本公司为此软件的知识产权持有人。版权、商标、专利、商业机密等与该软件相关的所有知识产权，以及与该软件相关的所有信息 (包括但不限于文字、图像、音频、视讯、图形、接口设计、配置、数据或电子文件等) 均受中华人民共和国法律及相应国际协议保护。</p>
                <p class="second">2. 未经本公司事先书面同意，用户不得出于任何商业或非商业目的，独立或允许任何第三方擅自使用或转让任何上述知识产权。本公司保留就该等行为追究法律责任的权利。</p>

                <p class="first">八、有限责任</p>
                <p class="second">1.本公司对服务所涉的技术和信息的有效性，准确性，正确性，可靠性，质量，稳定，完整和及时性均不作承诺和保证。</p>
                <p class="second">2. 不论在何种情况下，本公司均不对由于Internet连接故障，电脑，通讯或其他系统的故障，电力故障，罢工，劳动争议，暴乱，起义，骚乱，生产力或生产资料不足，火灾，洪水，风暴，爆炸，不可抗力，战争，政府行为，国际、国内法院的命令或第三方的不作为而造成的不能服务或延迟服务承担责任。</p>
                <p class="second">3. 不论是否可以预见，不论是源于何种形式的行为，本公司不对由以下原因造成的任何特别的，直接的，间接的，惩罚性的，突发性的或有因果关系的损害或其他任何损害（包括但不限于利润或利息的损失，营业中止，资料灭失）承担责任。</p>
                <p class="third">3.1. 使用或不能使用服务；</p>
                <p class="third">3.2. 未经授权的存取或修改数据或数据的传输；</p>
                <p class="third">3.3. 其它与服务相关事件，包括疏忽等，所造成的损害。</p>
                <p class="third">3.4. 您充分了解并同意，鉴于互联网体制及环境的特殊性，您在服务中分享的信息及个人资料有可能会被他人复制、转载、擅改或做其它非法用途；您在此已充分意识此类风险的存在，并确认此等风险应完全由您自行承担，本公司对此不承担任何责任。</p>
                <p class="second">4. 您了解并同意，在使用服务过程中可能存在来自任何他人的包括威胁性的、诽谤性的、令人反感的或非法的内容或行为或对他人权利的侵犯（包括知识产权）及匿名或冒名的信息的风险，基于服务使用规范所述，该等风险应由您自行承担，本公司对此不承担任何责任。</p>

                <p class="last"><span style="color:red">*</span> 本条款的最终解释权归济南亚爱特公司软件有限公司所有</p>
            </div>
        </div>
    </div>
</template>

<script>
import Vue from 'vue';
import { NavBar } from 'vant';
import { Toast } from 'vant';

export default {
  methods: {
    onClickLeft() {
      Toast('返回');
    },
  },
};
Vue.use(NavBar);
</script>


<style lang="scss" scoped>
  .wrap{
      background: white;
      padding: 0 0.8rem 2.5rem;
      font-size: 0.85rem;
      letter-spacing:0.1rem;
      font-weight: 530;
      line-height: 1.5rem;
    //   transform: translate(0,-1rem); 
      .card{
          .title{
              font-size: 1.3rem;
              text-align: center;
              margin-bottom: 1.5rem;
          }
          .first{
              margin:0.7rem 0;
          }
          .second{
              margin:0.3rem 0;
          }
          .third{
              margin-left: 0.5rem;
          }
          .last{
              margin-top: 0.7rem;
          }
      }
  }
</style>